import { render, staticRenderFns } from "./partnerManage2.vue?vue&type=template&id=a24a8ef6&"
import script from "./partnerManage2.vue?vue&type=script&lang=js&"
export * from "./partnerManage2.vue?vue&type=script&lang=js&"
import style0 from "./partnerManage2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports